import { H3 } from '@berlitz/globals'
import styled, { css } from 'styled-components'
import { CounterProps } from './interface'

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: ${({ theme }) => theme.space.xl};

  button {
    &:last-child {
      margin-right: 0;
    }
  }
`

export const InlineButtons = styled.div`
  margin-top: ${({ theme }) => theme.space.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  button {
    padding-left: ${({ theme }) => theme.space.md};
    padding-right: ${({ theme }) => theme.space.md};

    &:last-child {
      margin-right: 0;
    }
  }
`

export const Counter = styled.div<CounterProps>`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  color: ${({ theme }) => theme.colors.text02};
  float: right;
  margin-top: -20px;
  margin-right: ${({ theme }) => theme.space.md};
  position: relative;
  z-index: 1;

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.uiError};
    `}
`

export const ErrorMsg = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.uiError};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  padding: ${({ theme }) => `${theme.space.xxs} 0 0`};

  svg {
    margin-right: ${({ theme }) => theme.space.xxs};
  }
`

export const TextAreaBox = styled.div<CounterProps>`
  margin-top: 16px;
  ${({ error }) =>
    error
      ? css`
          textarea {
            border: 1px solid ${({ theme }) => theme.palette.danger100};
          }
        `
      : ''}
`

export const TextAreaLabel = styled.p`
  margin-bottom: ${({ theme }) => theme.space.xs}}
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text01}
`

export const IconCircle = styled.div`
  width: 106px;
  height: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.success100};
  border-radius: ${({ theme }) => theme.layout.xxxl};
  margin: auto;
  margin-bottom: ${({ theme }) => theme.space.lg};

  svg {
    font-size: 64px;
    color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  }
`

export const Success = styled.div`
  text-align: center;
`

export const Box = styled.div`
  ${H3} {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  textarea {
    resize: none;
    padding-right: ${({ theme }) => theme.space.lg};
  }

  button {
    padding-top: ${({ theme }) => theme.space.xs};
    padding-bottom: ${({ theme }) => theme.space.xs};
    margin-right: ${({ theme }) => theme.space.xs};
  }
`
